"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuickBuyEvents = exports.useOnClickEvent = void 0;
var AddBackorderDemandEvent = _interopRequireWildcard(require("@ori-events/add-backorder-demand"));
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailedEvent = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var LoyaltyDialogResultEvent = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var OpenProductInfoDialog = _interopRequireWildcard(require("@ori-events/open-product-info-dialog"));
var OpenShadePicker = _interopRequireWildcard(require("@ori-events/open-shade-picker"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _common = require("../../common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useOnClickEvent = ({
  addToBasketMethod,
  currentPrice,
  currentProductCode,
  lineNumber,
  name,
  placement,
  originalItemCode,
  position,
  hasAutoSubscription,
  isMultiShade
}) => {
  const event = (0, _react.useMemo)(() => {
    if (hasAutoSubscription) {
      return new CustomEvent(OpenProductInfoDialog.Name, {
        detail: {
          mode: OpenProductInfoDialog.DialogMode.StandardBuy,
          placement,
          productCodes: [currentProductCode]
        }
      });
    } else if (isMultiShade) {
      return new CustomEvent(OpenShadePicker.Name, {
        detail: {
          placement,
          productCode: currentProductCode
        }
      });
    } else if (lineNumber == null) {
      return new CustomEvent(AddToBasketEvent.Name, {
        detail: {
          formattedPrice: currentPrice,
          itemCode: currentProductCode,
          localName: name,
          method: addToBasketMethod,
          originalItemCode,
          placement,
          position,
          quantity: 1
        }
      });
    }
    return new CustomEvent(AddBackorderDemandEvent.Name, {
      detail: {
        formattedPrice: currentPrice,
        itemCode: currentProductCode,
        lineNumber,
        localName: name,
        placement,
        position,
        quantity: 1
      }
    });
  }, [addToBasketMethod, currentPrice, currentProductCode, hasAutoSubscription, isMultiShade, lineNumber, name, originalItemCode, placement, position]);
  return event;
};
exports.useOnClickEvent = useOnClickEvent;
const useQuickBuyEvents = ({
  currentProductCode,
  setState
}) => {
  const timeoutRef = (0, _react.useRef)();
  const clearAndResetState = (0, _react.useCallback)((state, delay) => {
    clearTimeout(timeoutRef.current);
    setState(state);
    timeoutRef.current = setTimeout(() => setState(_common.QUICK_BUY_BUTTON_STATE_DEFAULT), delay);
  }, [setState]);
  const eventHandlers = (0, _react.useMemo)(() => [{
    name: AddToBasketEvent.Name,
    listener: ({
      detail
    }) => {
      if (detail.itemCode === currentProductCode) {
        setState(_common.QUICK_BUY_BUTTON_STATE_LOADING);
      } else {
        setState(_common.QUICK_BUY_BUTTON_STATE_WAITING);
      }
    }
  }, {
    name: AddToBasketFailedEvent.Name,
    listener: () => {
      clearAndResetState(_common.QUICK_BUY_BUTTON_STATE_ERROR, 300);
    }
  }, {
    name: BasketUpdatedEvent.Name,
    listener: ({
      detail
    }) => {
      if (detail.lastAddedItem?.itemCode === currentProductCode) {
        clearAndResetState(_common.QUICK_BUY_BUTTON_STATE_SUCCESS, 3000);
      } else {
        setState(_common.QUICK_BUY_BUTTON_STATE_DEFAULT);
      }
    }
  }, {
    name: LoyaltyDialogResultEvent.Name,
    listener: ({
      detail
    }) => {
      if (detail.result === LoyaltyDialogResultEvent.LoyaltyDialogResults.CLOSE) {
        setState(_common.QUICK_BUY_BUTTON_STATE_DEFAULT);
      }
    }
  }], [clearAndResetState, currentProductCode, setState]);
  (0, _presentationHooks.useGlobalEvents)(eventHandlers);
  (0, _react.useEffect)(() => () => {
    clearTimeout(timeoutRef.current);
  }, []);
};
exports.useQuickBuyEvents = useQuickBuyEvents;
